import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import Home from '../Screens/HomeScreens/Home';
import DevActNavigation from './DevActNavigation';
import SimActNavigation from './SimActNavigation';

const AppNavigation = () => {
	const Stack = createNativeStackNavigator();
	return (
		<Stack.Navigator>
			<Stack.Screen
				name="Home"
				component={Home}
				options={{ headerShown: false }}
			/>
			<Stack.Screen
				name="Sim Navigation"
				component={SimActNavigation}
				options={{ headerShown: false }}
			/>
			<Stack.Screen
				name="Device Navigation"
				component={DevActNavigation}
				options={{ headerShown: false }}
			/>
		</Stack.Navigator>
	);
}

export default AppNavigation

const styles = StyleSheet.create({})